<template>
  <div class="default-layout">
    <div id="viewport" class="w-100 relative">
      <reset-password />
    </div>
  </div>
</template>
<script>
import ResetPassword from "../../../components/ResetPassword.vue";

export default {
  components: {
    ResetPassword,
  },
};
</script>
